import { QueryClientProvider } from '@tanstack/react-query';
import { ReactNode, Suspense, lazy } from 'react';
import { NON_PROD_ENVIRONMENTS, environmentName } from '../configuration';
import { queryClient } from '../lib/queryClient';

const showReactQueryDevtools = NON_PROD_ENVIRONMENTS.some(
  (env) => env === environmentName,
);

interface QueryProviderProps {
  children: ReactNode;
}

// Default export stubs to `() => null` when NODE_ENV !== "development" (i.e. every
// `vite build`). The /production entry always ships the real panel for explicit
// opt-in on non-prod deploys (development, preview, sandbox, local).
const ReactQueryDevtools = lazy(() =>
  import('@tanstack/react-query-devtools/production').then(
    ({ ReactQueryDevtools }) => ({
      default: ReactQueryDevtools,
    }),
  ),
);

export const QueryProvider = ({ children }: QueryProviderProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {showReactQueryDevtools && (
        <Suspense fallback={null}>
          <ReactQueryDevtools initialIsOpen={false} />
        </Suspense>
      )}
    </QueryClientProvider>
  );
};
